<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Reset Password</h4>
                                    <p>Please enter your new password.</p>
                                </div>
                                <vs-input 
                                  ref="password"
                                  type="password"
                                  data-vv-validate-on="blur"
                                  v-validate="'required|min:6|max:10'"
                                  name="password"
                                  label-placeholder="Password"
                                  placeholder="Password"
                                  v-model="password"
                                  class="w-full" />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <vs-input 
                                  type="password"
                                  v-validate="'min:6|max:10|confirmed:password'"
                                  data-vv-validate-on="blur"
                                  data-vv-as="password"
                                  name="confirm_password"
                                  label-placeholder="Confirm Password"
                                  placeholder="Confirm Password"
                                  v-model="confirm_password"
                                  class="w-full mt-6 mb-8" />
                                <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                    <vs-button type="border" to="/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go Back To Login</vs-button>
                                    <vs-button id="submitBtn"  class="w-full sm:w-auto vs-con-loading__containe" @click="resetPassword" :disabled="!validateForm">Reset</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import API from "@/API.js"
const axios = require('axios')

export default {
  data () {
    return {
        notify: 'Server Error',

        password: '',
        confirm_password: '',
        key: ''
    }
  },

  created() {    
    this.key = this.$route.params.key
  },

  computed: {
    validateForm () {
      return !this.errors.any() && this.password !== '' && this.confirm_password !== ''
    }
  },

  methods: {
    reset() {
        this.password = ''
        this.confirm_password = ''
    },

    resetPassword() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      if(this.key !== '' && this.key !== undefined){
        axios.post(API.endpoint + '/reset_password', {
            password: this.password,
            confirm_password: this.confirm_password,
            key: this.key
        }).then(res => {
            this.$vs.loading.close("#submitBtn > .con-vs-loading")
            this.notify = res.data.message.split('_').join(' ')

            this.$router.push({ path: '/login'})
            this.reset()

            this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
            })

        }).catch(error => {
            this.$vs.loading.close("#submitBtn > .con-vs-loading")

            if(error.response.status === 400){
            this.notify = 'Server Error'
            if(typeof error.response.data.message !== undefined) {
                this.notify = error.response.data.message.split('_').join(' ')
            }

            this.$vs.notify({
                title: 'Sorry',
                text: this.notify,
                color: 'danger',
                position: 'top-right'
            })
            }
        })
      }
    }
  }
}
</script>
